export default {
  title: 'Μη διαθέσιμο στο educational',
  body: 'Είσαι στην εκπαιδευτική έκδοση του athlisis, που δεν περιλαμβάνει αυτή τη λειτουργία. Αναβάθμισε στο πλήρες athlisis για να την ξεκλειδώσεις μαζί με όλες τις premium δυνατότητες.',
  titlePromo: 'Ξεκλείδωσε το πλήρες athlisis',
  bodyPromo: 'Είσαι στην εκπαιδευτική έκδοση. Αναβάθμισε με την μοναδική φοιτητική σου έκπτωση και πάρε όλες τις premium δυνατότητες.',
  bodyOffline: 'Αυτή η λειτουργία δεν είναι διαθέσιμη στην offline έκδοση του athlisis.',
  offerLabel: 'Φοιτητική προσφορά',
  offerNote: 'Για σένα, λόγω της σχολής σου — με δυνατότητα έως 3 δόσεων.',
  autoApplied: 'Η έκπτωση εφαρμόζεται αυτόματα κατά την αναβάθμιση.',
  ctaPurchase: 'Αναβάθμισε τώρα',
  unavailable: 'Μη διαθέσιμο στο educational',
}
